export const mainNavBorderColors = {
	black: 'border-black',
	// keep these as is for backwards compatibility - starts here
	elanco_blue: 'border-elanco-blue',
	pet_green: 'border-pet-green',
	vet_purple: 'border-vet-purple',
	// keep these as is for backwards compatibility - ends here
	white: 'border-white',
	// new colors below - starts here
	'elanco-blue': 'border-elanco-blue',
	'pet-green': 'border-pet-green',
	'vet-purple': 'border-vet-purple',
	// new colors below - ends here
}

export type MainNavBorderColor = keyof typeof mainNavBorderColors
